import { unsafeCSS, html, nothing } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
const styles = "/* ------------------------------------ *\\\n#SPINNER\n\\* ------------------------------------ */\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n@keyframes loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes spinner-circle-animation {\n  0%, 25% {\n    stroke-dashoffset: 280;\n    transform: rotate(0);\n  }\n  50%, 75% {\n    stroke-dashoffset: 75;\n    transform: rotate(45deg);\n  }\n  100% {\n    stroke-dashoffset: 280;\n    transform: rotate(360deg);\n  }\n}\n:host {\n  --spinner-stroke-width: 10;\n  --spinner-large-width: 4.5rem;\n  --spinner-small-width: 1.5rem;\n}\n\n.leaf-c-spinner__label {\n  font-family: var(--leaf-typography-label-small-font-family);\n  font-size: var(--leaf-typography-label-small-font-size);\n  font-weight: var(--leaf-typography-label-small-font-weight);\n  line-height: var(--leaf-typography-label-small-line-height);\n}\n\n.leaf-c-spinner--large {\n  --spinner-height: var(--spinner-large-width);\n  --spinner-width: var(--spinner-large-width);\n  --icon-color: var(--leaf-color-content-brand);\n}\n.leaf-c-spinner--large .leaf-c-spinner__icon {\n  display: block;\n}\n.leaf-c-spinner--large .leaf-c-spinner__label {\n  display: block;\n  margin-top: var(--leaf-spacing-8);\n}\n\n.leaf-c-spinner--small {\n  --spinner-height: var(--spinner-small-width);\n  --spinner-width: var(--spinner-small-width);\n  --icon-color: var(--leaf-color-content-brand);\n}\n.leaf-c-spinner--small .leaf-c-spinner__label {\n  display: inline-block;\n  margin-left: var(--leaf-spacing-4);\n  vertical-align: 0.35rem;\n}\n\n.leaf-c-spinner--inverted {\n  --icon-color: var(--leaf-color-content-brand-knockout);\n  --label-color: var(--leaf-color-content-brand-knockout);\n}\n\n.leaf-c-spinner__label {\n  color: var(--label-color, var(--leaf-color-content-default));\n}\n\n.leaf-c-spinner--hidden-label .leaf-c-spinner__label {\n  display: none;\n}\n\n.leaf-c-spinner__icon {\n  height: var(--spinner-height, 1em);\n  width: var(--spinner-width, 1em);\n}\n.leaf-c-spinner__icon circle {\n  fill: transparent;\n  stroke: var(--icon-color, currentColor);\n  stroke-linecap: round;\n  stroke-width: var(--spinner-stroke-width);\n  transform-origin: 50% 50%;\n}\n\n.leaf-c-spinner--indeterminate .leaf-c-spinner__icon {\n  animation: loading 2s linear 0s infinite;\n}\n.leaf-c-spinner--indeterminate .leaf-c-spinner__icon circle {\n  animation-duration: 1.4s;\n  animation-iteration-count: infinite;\n  animation-name: spinner-circle-animation;\n  animation-timing-function: ease-in-out;\n}\n\n.leaf-c-spinner--determinate .leaf-c-spinner__icon {\n  overflow: hidden;\n  transform: rotate(-90deg);\n  transform-origin: center center;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const CIRCUMFERENCE = 282.7433388230814;
const _LeafSpinner = class _LeafSpinner extends LeafElement {
  constructor() {
    super();
    this.determinate = false;
    this.inverted = false;
    this.progress = 0;
    const num = Math.floor(Math.random() * 9e5) + 1e5;
    this.labelId = `leaf-spinner-${num}`;
  }
  renderDeterminateSpinner() {
    let progress = Math.max(Math.min(100, this.progress), 0);
    if (progress === 0) {
      progress = 1;
    }
    const dashOffset = progress * CIRCUMFERENCE / 100;
    return html`
      <svg class="leaf-c-spinner__icon" aria-hidden="true" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" stroke-dasharray="${dashOffset} ${CIRCUMFERENCE}"></circle>
      </svg>
    `;
  }
  renderInDeterminateSpinner() {
    return html`
      <svg class="leaf-c-spinner__icon" aria-hidden="true" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" stroke-dasharray="${CIRCUMFERENCE}"></circle>
      </svg>
    `;
  }
  render() {
    const componentClassNames = {
      "leaf-c-spinner": true,
      "leaf-c-spinner--large": this.size === "large",
      "leaf-c-spinner--small": this.size === "small",
      "leaf-c-spinner--inverted": this.inverted,
      "leaf-c-spinner--determinate": this.determinate,
      "leaf-c-spinner--indeterminate": !this.determinate
    };
    return html`
      <div
        class="${classMap(componentClassNames)}"
        role="progressbar"
        aria-labelledby="${this.labelId}"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow="${this.determinate ? this.progress : nothing}"
        part="base"
      >
        ${this.determinate ? this.renderDeterminateSpinner() : this.renderInDeterminateSpinner()}
        <div id="${this.labelId}" class="leaf-c-spinner__label" part="label">
          <slot></slot>
        </div>
      </div>
    `;
  }
};
_LeafSpinner.styles = unsafeCSS(styles);
let LeafSpinner = _LeafSpinner;
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafSpinner.prototype, "determinate", 2);
__decorateClass([
  property()
], LeafSpinner.prototype, "size", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafSpinner.prototype, "inverted", 2);
__decorateClass([
  property({ reflect: true, type: Number })
], LeafSpinner.prototype, "progress", 2);
export {
  LeafSpinner
};
//# sourceMappingURL=spinner.component.js.map
